module.exports = __webpack_public_path__ + "img/coppel.022dedfc.svg";